import Vue from 'vue'
import { Dialog } from 'vant'
import moment from 'moment'
import cookie from 'js-cookie'
import html2canvas from 'html2canvas'
import store from '@/store/index'
import TagUtils from '@/utils/tag'
import AppUtils from './app'
import DeviceUtils from './device'
import bwipjs from 'bwip-js'
let codeCanvas = null

const utils = {
  renderTagImage(content='[]', size = '') {
    // 解析模板数据并转图片
    return new Promise(resolve => {
      this.generateTagCanvas(content, size)
      .then(res => {
        if (res) {
          resolve(res.toDataURL())
        } else {
          resolve(null)
        }
      })
    })
  },
  generateTagCanvas(content = '[]', size = '') {
    // 将标签模板内容转换成
    return new Promise(resolve => {
      try {
        const dataType = this.checkType(content)
        const templateData = dataType === 'string' ? JSON.parse(content || '[]') : content
        const sizeArray = size.toLowerCase().split('x')
        const w = sizeArray[0] || 0
        const h = sizeArray[1] || 0
  
        const data = {
          content: templateData,
          w,
          h
        }
        
        const tagHtml = TagUtils.generateTagHtml(data)
        const renderElement = document.createElement('div')
        renderElement.className = 'hide-element'
        renderElement.innerHTML = tagHtml
        document.body.appendChild(renderElement)
        html2canvas(renderElement, {
          width: w,
          height: h,
          scale: 2,
          useCORS: true,
          allowTaint: true
        })
        .then(function(canvas) {
          document.body.removeChild(renderElement)
          resolve(canvas)
        })
      } catch (error) {
        console.error('解析模板出错', error)
        resolve(null)
      }
    })
  },
  generatePrintData(content = '[]', size = '') {
    // 生成打印机需要的zpl数据
    return new Promise(resolve => {
      const { imageToZ64 } = window
      if (!imageToZ64) {
        resolve(null)
        return
      }

      this.generateTagCanvas(content, size)
      .then(canvas => {
        if (canvas) {
          const data = imageToZ64(canvas, { notrim: true })

          resolve(data)
        } else {
          resolve(null)
        }
      })
    })
  },
  randomString(length = 8) {
    // 生成指定长度的随机字符串
    const string = Math.random().toString(36).slice(-length)

    return string || this.randomString(length)
  },
  checkType(data) {
    // 检查数据类型
    const match = Object.prototype.toString.apply(data).match(/\s.*\]$/g)
    const type = (match && match[0]) ? match[0].substring(1, match[0].length - 1) : ''

    return type.toLowerCase()
  },
  matchTagSize(size) {
    // 匹配标签size，使用字典中的remark
    const sizeConfig = store.state.sizeConfig || []
    const match = sizeConfig.find(i => i.name.toLowerCase() === size.toLowerCase())
    
    return match ? match.remark : ''
  },
  fullScreenTemplatePreview(imageUrl) {
    // 打开全屏预览
    if (!imageUrl) return
    const previewDom = document.createElement('div')
    previewDom.className = 'full-screen-previewer'
    const imageDom = document.createElement('div')
    imageDom.className = 'image-container'
    imageDom.style.backgroundImage = `url(${imageUrl})`
    previewDom.appendChild(imageDom)
    previewDom.addEventListener('click', () => {
      document.body.removeChild(previewDom)
    })

    document.body.appendChild(previewDom)
  },
  jsBridgeReady() {
    // 检测js-bridge是否加载成功，10s未成功则失败
    return new Promise(resolve => {
      window.document.addEventListener('UniAppJSBridgeReady', () => {
        resolve(true)
      })

      setTimeout(() => {
        resolve(false)
      }, 10000)
    })
  },
  matchCodeConfig(code = '') {
    // 根据码值获取配置
    return store.dispatch('setCodeRules')
    .then(res => {
      let rule = null
      res.forEach((r) => {
        if (code.toLowerCase().startsWith(`${r.prefix}`.toLocaleLowerCase()) && code.length === r.length) {
          rule = Object.assign({}, r)
        }
      })
      
      return rule
    })
  },
  confirm(opts = {}) {
    const defaultOptions = {
      title: '请确认'
    }

    return new Promise(resolve => {
      Dialog
      .confirm(Object.assign({}, defaultOptions, opts))
      .then(() => {
        resolve(true)
      })
      .catch(() => {
        resolve(false)
      })
    })
  },
  generateCode(code, type = 'datamatrix') {
    // 生成各种码图像
    // 支持的code列表：https://github.com/metafloor/bwip-js/wiki/BWIPP-Barcode-Types
    if (codeCanvas) {
      codeCanvas = null
    }

    codeCanvas = document.createElement('canvas')
    const opts = {
      bcid: type,
      text: `${code}`,
      textxalign: 'center' 
    }

    try {
      bwipjs.toCanvas(codeCanvas, opts)
      const base64 = codeCanvas.toDataURL('image/png')
      return base64
    } catch (error) {
      console.log('生成码出错', error)
    }
  },
}

moment.locale('zh-cn')
Vue.prototype.$moment = moment
Vue.prototype.$cookie = cookie 
export const utilsObject = Object.assign(utils, { app: AppUtils, device: DeviceUtils })
Vue.prototype.$utils = utilsObject